// extracted by mini-css-extract-plugin
export default {"block":"TicketIssueLog_block__t-zWB"};